import styled from 'styled-components';

export const RedText = styled.span`
  color: ${({ theme }) => theme.palette.error} !important;
  font-weight: ${(props) => props.theme.fontWeightBold} !important;
`;
